import React, { useContext, useState } from "react";
import { css } from "emotion";
import { colors, boxStyles, textSizes } from "../styles/theme";
import GenericCard from "./GenericCard";
import IconText from "./IconText";
import { GlobalContext } from "../context/GlobalState";

const OverviewCardSingleView = () => {
  const { currentSpotlight: spotlight } = useContext(GlobalContext);
  const [isPaused, setIsPaused] = useState(true);

  const createdDate = new Date(spotlight.createdAt);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const dateString = `${
    months[createdDate.getMonth()]
  } ${createdDate.getDate()}, ${createdDate.getFullYear()}`;

  let _audio;

  const handlePlayPause = () => {
    if (isPaused) {
      const allAudio = document.getElementsByTagName("audio");
      for (let i = 0; i < allAudio.length; i++) {
        allAudio[i].pause();
      }

      _audio.play();
      setIsPaused(false);
    } else {
      _audio.pause();
      setIsPaused(true);
    }
  };

  return (
    <div className={container}>
      <p className="date">{dateString}</p>
      <GenericCard style="card">
        <div className="top">
          <h4>{spotlight.name}</h4>
          <p>{spotlight.isActive ? "Default" : ""}</p>
        </div>
        <div
          className={preview}
          style={{ backgroundColor: spotlight.primaryColor }}
        >
          {spotlight.type === "text" ? (
            <div className="spotlt_container">
              <div className="spotlt_content">
                <p
                  className="spotlt_text"
                  style={{ color: spotlight.secondaryColor }}
                >
                  {spotlight.headline}
                </p>
                <a
                  className={"spotlt_button" + (isPaused ? "" : " pause")}
                  style={{
                    borderColor: spotlight.secondaryColor,
                    color: spotlight.secondaryColor,
                    display: spotlight.ctaText.length > 0 ? "flex" : "none",
                  }}
                >
                  {spotlight.ctaText.toUpperCase()}
                </a>
              </div>
            </div>
          ) : (
            <div className="spotlt_container">
              <div className="spotlt_content">
                <p
                  className="spotlt_text"
                  style={{ color: spotlight.secondaryColor }}
                >
                  {spotlight.headline}
                </p>
                <a
                  onClick={handlePlayPause}
                  className={"spotlt_button" + (isPaused ? "" : " pause")}
                  style={{
                    borderColor: spotlight.secondaryColor,
                    color: spotlight.secondaryColor,
                  }}
                >
                  {isPaused ? "LISTEN" : "PAUSE"}
                  <div
                    className="spotlt_play-icon-circle"
                    style={{
                      display: "inline-block",
                      backgroundColor: spotlight.secondaryColor,
                    }}
                  >
                    <div
                      className="spotlt_icon"
                      style={{
                        borderColor: `transparent transparent transparent ${spotlight.primaryColor}`,
                      }}
                    />
                  </div>
                  <audio
                    src={spotlight.fileUrl}
                    ref={(element) => (_audio = element)}
                    onEnded={() => setIsPaused(true)}
                  />
                </a>
              </div>
            </div>
          )}
        </div>
        <div className="bottom">
          <div className="icon-container">
            <IconText
              icon="eye"
              text={spotlight.visit ? spotlight.visit : "-"}
            />
            <IconText
              icon="play"
              text={spotlight.start ? spotlight.start : "-"}
            />
            <IconText
              icon="mouse-pointer"
              text={spotlight.click ? spotlight.click : "-"}
            />
          </div>
        </div>
      </GenericCard>
    </div>
  );
};

export default OverviewCardSingleView;

const container = css`
  margin-bottom: 15px;
  .spotlt_container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    color: rgb(255, 255, 255);
    width: 100%;
    padding: 2px 12px;

    .spotlt_content {
      display: flex;
      max-width: 800px;
      justify-content: center;
      align-content: center;
      width: 100%;

      p {
        align-self: center;
        font-weight: 400;
        color: rgb(255, 255, 255);
        line-height: 14px;
        margin: 0;
        font-size: 12px;
        flex: 1 1 0%;
      }
    }
  }

  .spotlt_button {
    background-color: transparent;
    cursor: pointer;
    margin-left: 30px;
    transition-duration: 0.2s;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 1.33px;
    display: flex;
    align-items: center;
    height: 35px;
    align-self: center;
    min-width: 60px;
    color: rgb(255, 255, 255);
    border-radius: 3px;
    padding: 3px 18px;
    border-width: 2px;
    border-style: solid;
    border-color: rgb(255, 255, 255);
    border-image: initial;
    min-width: 98px;
    justify-content: center;
    box-sizing: border-box;
    font-size: 11px;
    padding: 0px 6px;
    margin-left: 10px;
    height: 28px;
    flex-shrink: 1;

    .spotlt_play-icon-circle {
      display: inline-block;
      height: 18px;
      width: 18px;
      margin-left: 8px;
      position: relative;
      transition-duration: 0.2s;
      border-radius: 50%;

      .spotlt_icon {
        display: block;
        will-change: border-width;
        cursor: pointer;
        left: 6px;
        position: absolute;
        top: 4px;
        transition: all 0.2s ease 0s;
        border-style: solid;
        border-width: 5px 0px 5px 8px;
      }
    }

    &.pause {
      .spotlt_icon {
        height: 10px;
        transform: translateX(-1px);
        border-style: double;
        border-width: 0px 0px 0px 8px;
      }
    }
  }

  .date {
    text-align: center;
    font-size: ${textSizes.normal};
    color: ${colors.placeholderText};
    user-select: none;
    margin-top: 24px;
  }
  .card {
    width: 100%;
    flex-direction: column;
    margin-top: 6px;
    transition-duration: 0.2s;

    &:hover {
      transform: translateY(-2px);
    }

    .preview {
      background-color: royalblue;
    }

    .top,
    .bottom {
      display: flex;
      justify-content: space-between;
      padding: ${boxStyles.standardPadding};
    }

    .top {
      h4 {
        font-size: ${textSizes.intermediate};
        letter-spacing: 1px;
      }
      p {
        font-size: ${textSizes.intermediate};
        color: ${colors.accentColor};
      }
    }

    .bottom {
      .icon-container {
        display: flex;
      }
      .more-button {
        cursor: pointer;
        font-size: ${textSizes.normal};
        display: flex;
        align-items: center;
        color: ${colors.placeholderText};
        transition-duration: 0.2s;

        &:hover {
          opacity: 0.8;
        }

        .icon {
          padding-left: 2px;
          font-size: 10px;
        }
      }
    }
  }
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .spotlt_container {
      .spotlt_content {
        .spotlt_text {
          font-size: 14px;
          flex: 0 0 auto;
        }

        .spotlt_button {
          font-size: 13px;
          padding: 1px 12px;
          margin-left: 24px;
          height: 30px;
          min-width: 108px;
        }
      }
    }

    .date {
      margin-top: 40px;
    }

    .card {
      .top {
        padding: ${boxStyles.desktopPadding};
        h4 {
          letter-spacing: 1px;
          flex: 1;
          text-align: center;
          font-size: ${textSizes.subtitle};
        }
      }
      .bottom {
        padding: 15px ${boxStyles.desktopPadding};

        .icon-container {
          justify-content: center;
          flex: 1;
        }
      }
    }
  }
`;

const preview = css`
  background-color: ${colors.brandColor};
  display: flex;
  width: 100%;
  .innerBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${boxStyles.standardPadding};
    .headline-container {
      max-width: 70%;
      p {
        font-size: ${textSizes.normal};
        color: white;
      }
    }

    button {
      background-color: transparent;
      border: none;
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 0;
    }
  }

  .widget-button {
    min-width: 100px;
    padding: 12px 0;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .innerBox {
      padding: ${boxStyles.desktopPadding};
      .headline-container {
        width: 100%;
        max-width: 100%;
        p {
          text-align: center;
          font-size: ${textSizes.intermediate};
        }
      }
    }
  }
`;
